module.exports = __webpack_public_path__ + "static/assets/c7e975a79a756d3ffcd76f491dbf85d5.png";